export const TeamChatActionType = {
  FETCH_CHANNELS: 'teamChat/FETCH_CHANNELS',
  FETCH_CHANNELS_SUCCESS: 'teamChat/FETCH_CHANNELS_SUCCESS',
  FETCH_CHANNELS_FAILURE: 'teamChat/FETCH_CHANNELS_FAILURE',

  FETCH_CHANNEL_SUCCESS: 'teamChat/FETCH_CHANNEL_SUCCESS',

  FETCH_MESSAGES: 'teamChat/FETCH_MESSAGES',
  FETCH_MESSAGES_SUCCESS: 'teamChat/FETCH_MESSAGES_SUCCESS',
  FETCH_MESSAGES_FAILURE: 'teamChat/FETCH_MESSAGES_FAILURE',

  SEND_MESSAGE: 'teamChat/SEND_MESSAGE',
  SEND_MESSAGE_SUCCESS: 'teamChat/SEND_MESSAGE_SUCCESS',
  SEND_MESSAGE_FAILURE: 'teamChat/SEND_MESSAGE_FAILURE',

  MESSAGE_RECEIVED: 'teamChat/MESSAGE_RECEIVED',

  SET_ACTIVE_CHANNEL: 'teamChat/SET_ACTIVE_CHANNEL',

  SET_CONNECTION_STATUS: 'teamChat/SET_CONNECTION_STATUS',

  MARK_AS_READ: 'teamChat/MARK_AS_READ',
  MESSAGES_READ: 'teamChat/MESSAGES_READ',

  TYPING_STARTED: 'teamChat/TYPING_STARTED',
  TYPING_STOPPED: 'teamChat/TYPING_STOPPED',

  UPDATE_MESSAGE: 'teamChat/UPDATE_MESSAGE',
  UPDATE_MESSAGE_SUCCESS: 'teamChat/UPDATE_MESSAGE_SUCCESS',
  UPDATE_MESSAGE_FAILURE: 'teamChat/UPDATE_MESSAGE_FAILURE',

  MESSAGE_UPDATED: 'teamChat/MESSAGE_UPDATED',

  ADD_REACTION: 'teamChat/ADD_REACTION',
  ADD_REACTION_SUCCESS: 'teamChat/ADD_REACTION_SUCCESS',
  ADD_REACTION_FAILURE: 'teamChat/ADD_REACTION_FAILURE',

  REMOVE_REACTION: 'teamChat/REMOVE_REACTION',
  REMOVE_REACTION_SUCCESS: 'teamChat/REMOVE_REACTION_SUCCESS',
  REMOVE_REACTION_FAILURE: 'teamChat/REMOVE_REACTION_FAILURE',

  REACTION_ADDED: 'teamChat/REACTION_ADDED',
  REACTION_REMOVED: 'teamChat/REACTION_REMOVED',

  UPLOAD_ATTACHMENT: 'teamChat/UPLOAD_ATTACHMENT',
  UPLOAD_ATTACHMENT_SUCCESS: 'teamChat/UPLOAD_ATTACHMENT_SUCCESS',
  UPLOAD_ATTACHMENT_FAILURE: 'teamChat/UPLOAD_ATTACHMENT_FAILURE',

  FETCH_PRESENCE: 'teamChat/FETCH_PRESENCE',
  FETCH_PRESENCE_SUCCESS: 'teamChat/FETCH_PRESENCE_SUCCESS',
  FETCH_PRESENCE_FAILURE: 'teamChat/FETCH_PRESENCE_FAILURE',

  USER_ONLINE: 'teamChat/USER_ONLINE',
  USER_OFFLINE: 'teamChat/USER_OFFLINE',

  PIN_MESSAGE: 'teamChat/PIN_MESSAGE',
  PIN_MESSAGE_SUCCESS: 'teamChat/PIN_MESSAGE_SUCCESS',
  PIN_MESSAGE_FAILURE: 'teamChat/PIN_MESSAGE_FAILURE',

  UNPIN_MESSAGE: 'teamChat/UNPIN_MESSAGE',
  UNPIN_MESSAGE_SUCCESS: 'teamChat/UNPIN_MESSAGE_SUCCESS',
  UNPIN_MESSAGE_FAILURE: 'teamChat/UNPIN_MESSAGE_FAILURE',

  FETCH_PINNED_MESSAGES: 'teamChat/FETCH_PINNED_MESSAGES',
  FETCH_PINNED_MESSAGES_SUCCESS: 'teamChat/FETCH_PINNED_MESSAGES_SUCCESS',
  FETCH_PINNED_MESSAGES_FAILURE: 'teamChat/FETCH_PINNED_MESSAGES_FAILURE',

  MESSAGE_PINNED: 'teamChat/MESSAGE_PINNED',
  MESSAGE_UNPINNED: 'teamChat/MESSAGE_UNPINNED',

  PIN_CHAT: 'teamChat/PIN_CHAT',
  PIN_CHAT_SUCCESS: 'teamChat/PIN_CHAT_SUCCESS',
  PIN_CHAT_FAILURE: 'teamChat/PIN_CHAT_FAILURE',

  UNPIN_CHAT: 'teamChat/UNPIN_CHAT',
  UNPIN_CHAT_SUCCESS: 'teamChat/UNPIN_CHAT_SUCCESS',
  UNPIN_CHAT_FAILURE: 'teamChat/UNPIN_CHAT_FAILURE',

  FETCH_USER_MENTIONS: 'teamChat/FETCH_USER_MENTIONS',
  FETCH_USER_MENTIONS_SUCCESS: 'teamChat/FETCH_USER_MENTIONS_SUCCESS',
  FETCH_USER_MENTIONS_FAILURE: 'teamChat/FETCH_USER_MENTIONS_FAILURE',

  REQUEST_ENTITY_CHAT_ATTACHMENT: 'teamChat/REQUEST_ENTITY_CHAT_ATTACHMENT',
  CLEAR_ENTITY_CHAT_ATTACHMENT: 'teamChat/CLEAR_ENTITY_CHAT_ATTACHMENT',

  REQUEST_ENTITY_CHAT_FILTER: 'teamChat/REQUEST_ENTITY_CHAT_FILTER',
  CLEAR_ENTITY_CHAT_FILTER: 'teamChat/CLEAR_ENTITY_CHAT_FILTER',

  RESET_STATE: 'teamChat/RESET_STATE',
};

export const TeamChatConnectionStatus = {
  DISCONNECTED: 'Disconnected',
  CONNECTING: 'Connecting',
  CONNECTED: 'Connected',
  RECONNECTING: 'Reconnecting',
};

export const TeamChatChannelType = {
  INTERNAL: 'internal',
  GLOBAL: 'global',
  TPO: 'tpo',
};

export const TeamChatMemberIdType = {
  VIA_USER_ID: 'ViaUserId',
  VIA_PHONE_NUMBER: 'ViaPhoneNumber',
  VIA_AI_PERSONA_ID: 'ViaAiPersonaId',
  VIA_SYSTEM: 'ViaSystem',
};

export const TeamChatMessagePayloadType = {
  TEXT: 'Text',
  FILE: 'File',
};

export const TeamChatSignalREventType = {
  RECEIVE_MESSAGE: 'ReceiveMessage',
  MESSAGES_READ: 'MessagesRead',
  TYPING_STARTED: 'TypingStarted',
  TYPING_STOPPED: 'TypingStopped',
  MESSAGE_UPDATED: 'MessageUpdated',
  REACTION_ADDED: 'ReactionAdded',
  REACTION_REMOVED: 'ReactionRemoved',
  USER_ONLINE: 'UserOnline',
  USER_OFFLINE: 'UserOffline',
  MESSAGE_PINNED: 'MessagePinned',
  MESSAGE_UNPINNED: 'MessageUnpinned',
};

export const TeamChatSignalRMessageType = {
  JOIN_CHAT: 'JoinChat',
  LEAVE_CHAT: 'LeaveChat',
  START_TYPING: 'StartTyping',
  STOP_TYPING: 'StopTyping',
};

export const TEAM_CHAT_MESSAGES_PAGE_SIZE = 50;

export const TEAM_CHAT_MENTION_SYMBOL = '@';

export const TEAM_CHAT_MENTION_MAX_SUGGESTIONS = 10;

export const TEAM_CHAT_MENTION_DEBOUNCE_MS = 300;

export const TEAM_CHAT_TYPING_DEBOUNCE_MS = 3_000;
